module.exports = __webpack_public_path__ + "static/media/calling.4d587a71.svg";